/* ============================================================
   Tikzer theme scripts — vanilla, framework-free
   ============================================================ */
(function () {
  'use strict';

  var theme = window.theme || {};
  theme.routes = theme.routes || {};
  theme.strings = theme.strings || {};

  /* --- Helpers ------------------------------------------------ */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { el && el.addEventListener(ev, fn, opts); }

  function fetchJSON(url, options) {
    options = options || {};
    options.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, options.headers || {});
    return fetch(url, options).then(function (r) { return r.json(); });
  }

  function trapFocusInit(container) {
    var focusable = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return function () {};
    var first = focusable[0], last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    first.focus();
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* --- Toast -------------------------------------------------- */
  function toast(message) {
    var root = $('#ToastRoot');
    if (!root) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = '<svg class="icon" viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.5l3.2 3.2L15 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
    el.querySelector('span').textContent = message;
    root.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'opacity .3s ease, transform .3s ease';
      el.style.opacity = '0';
      el.style.transform = 'translateY(10px)';
      setTimeout(function () { el.remove(); }, 320);
    }, 2600);
  }
  theme.toast = toast;

  /* --- Drawer controller ------------------------------------- */
  var DrawerManager = {
    active: null,
    release: null,
    scrollY: 0,
    open: function (drawer, trigger) {
      if (!drawer) return;
      this.close();
      this.active = drawer;
      this.trigger = trigger || document.activeElement;
      this.scrollY = window.scrollY;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      this.release = trapFocusInit(drawer.querySelector('.drawer__panel') || drawer);
      drawer.dispatchEvent(new CustomEvent('drawer:open'));
    },
    close: function () {
      if (!this.active) return;
      var drawer = this.active;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      if (this.release) this.release();
      if (this.trigger && this.trigger.focus) this.trigger.focus();
      drawer.dispatchEvent(new CustomEvent('drawer:close'));
      this.active = null;
    }
  };
  theme.drawers = DrawerManager;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      DrawerManager.open(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      DrawerManager.close();
    }
    var facetToggle = e.target.closest('[data-facets-toggle]');
    if (facetToggle) {
      e.preventDefault();
      var facets = $('.facets');
      if (facets) {
        var open = facets.classList.toggle('is-open');
        document.body.classList.toggle('overflow-hidden', open);
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') DrawerManager.close();
  });

  /* --- Cart count sync --------------------------------------- */
  function syncCartCount(count) {
    $$('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
      el.hidden = count < 1;
    });
  }

  function updateCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var html = sections[key];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      $$('[data-cart-section="' + key + '"]').forEach(function (target) {
        var fresh = doc.querySelector('[data-cart-section="' + key + '"]');
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
    });
    var countSource = $('[data-cart-count-source]');
    if (countSource) syncCartCount(parseInt(countSource.getAttribute('data-cart-count-source'), 10) || 0);
  }
  theme.updateCartSections = updateCartSections;

  function cartSectionList() {
    var list = ['cart-drawer'];
    if (document.body.classList.contains('template-cart')) list.push('main-cart');
    return list.join(',');
  }

  /* --- Add to cart (delegated for product cards + forms) ------ */
  function addToCart(formData, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    formData.set('sections', cartSectionList());
    formData.set('sections_url', window.location.pathname);
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          toast(data.description || data.message || theme.strings.unavailable);
          return Promise.reject(data);
        }
        updateCartSections(data.sections);
        toast(theme.strings.addedToCart || 'Added to cart');
        if (theme.cartType === 'drawer') {
          DrawerManager.open(document.getElementById('CartDrawer'), button);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        return data;
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      });
  }
  theme.addToCart = addToCart;

  /* --- ProductForm element ----------------------------------- */
  function defineEl(name, ctor) {
    if (!customElements.get(name)) customElements.define(name, ctor);
  }

  defineEl('product-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.querySelector('[type="submit"]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
    onSubmit(e) {
      e.preventDefault();
      if (this.button && this.button.disabled) return;
      addToCart(new FormData(this.form), this.button).catch(function () {});
    }
  });

  /* --- QuantityInput element --------------------------------- */
  defineEl('quantity-input', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      var self = this;
      this.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.qty === 'up' ? 1 : -1;
          var min = parseInt(self.input.min, 10) || 0;
          var val = (parseInt(self.input.value, 10) || 0) + step;
          if (val < min) val = min;
          self.input.value = val;
          self.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  });

  /* --- VariantPicker element --------------------------------- */
  defineEl('variant-picker', class extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('script[type="application/json"]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.section = this.dataset.section;
      this.url = this.dataset.url;
      this.addEventListener('change', this.onChange.bind(this));
      this.onChange();
    }
    selectedOptions() {
      return $$('input:checked, select', this).map(function (el) {
        return el.tagName === 'SELECT' ? el.value : el.value;
      });
    }
    currentVariant() {
      var opts = this.selectedOptions();
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    onChange() {
      var variant = this.currentVariant();
      // update "current value" labels (also mirror title for tooltip)
      $$('.variant-option', this).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('.variant-option__current');
        if (checked && label) {
          label.textContent = checked.value;
          label.setAttribute('title', checked.value);
        }
      });
      var idInput = $('#variant-id-' + this.section) || $('input[name="id"]', this.closest('product-form') || document);
      var priceEl = document.getElementById('price-' + this.section);
      var addBtn = document.getElementById('add-' + this.section);
      var stockEl = document.getElementById('stock-' + this.section);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = theme.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (this.url) {
        window.history.replaceState({}, '', this.url + '?variant=' + variant.id);
      }
      if (priceEl) this.renderPrice(priceEl, variant);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.querySelector('span').textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      if (stockEl) this.renderStock(stockEl, variant);
      // switch gallery image
      if (variant.featured_media) {
        var gallery = document.getElementById('gallery-' + this.section);
        if (gallery && gallery.switchTo) gallery.switchTo(variant.featured_media.id);
      }
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }
    renderPrice(el, variant) {
      var price = '<span class="price__regular">' + theme.formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price > variant.price) {
        price = '<span class="price__sale">' + theme.formatMoney(variant.price) + '</span>' +
          '<s class="price__compare">' + theme.formatMoney(variant.compare_at_price) + '</s>';
      }
      el.innerHTML = price;
    }
    renderStock(el, variant) {
      var qty = variant.inventory_quantity;
      var mgmt = variant.inventory_management;
      var policy = variant.inventory_policy;
      if (!variant.available) {
        el.innerHTML = '<span class="stock-dot stock-dot--out"></span> ' + theme.strings.soldOut;
      } else if (mgmt && policy === 'deny' && qty > 0 && qty <= 10) {
        el.innerHTML = '<span class="stock-dot stock-dot--low"></span> Only ' + qty + ' left';
      } else {
        el.innerHTML = '<span class="stock-dot"></span> In stock';
      }
    }
  });

  /* --- ProductGallery element (Sprint 7 — counter, zoom, tick) ---- */
  defineEl('product-gallery', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.items = $$('.product__media-item', this);
      this.thumbs = $$('.product__thumb', this);
      this.total = this.items.length;
      this.counterIdx = this.querySelector('[data-counter-index]');
      this.counterKind = this.querySelector('[data-counter-kind]');
      this.progress = this.querySelector('[data-gallery-progress]');

      // Thumb click + roving tabindex (arrow keys / Home / End)
      this.thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          self.switchTo(thumb.dataset.mediaId);
        });
        thumb.addEventListener('keydown', function (e) {
          var dir = 0;
          if (e.key === 'ArrowRight') dir = 1;
          else if (e.key === 'ArrowLeft') dir = -1;
          else if (e.key === 'Home') dir = -i;
          else if (e.key === 'End') dir = (self.thumbs.length - 1 - i);
          else return;
          e.preventDefault();
          var nextIdx = (i + dir + self.thumbs.length) % self.thumbs.length;
          var next = self.thumbs[nextIdx];
          next.focus();
          self.switchTo(next.dataset.mediaId);
        });
      });

      // Cursor-tracked zoom — desktop, fine pointer, no reduced motion
      this._canZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches
                   && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._zoomRaf = 0;
      this._zoomRect = null;
      this._activeZoom = null;

      if (this._canZoom) {
        this._bindZoom = function (zoom) {
          if (!zoom || zoom._zoomBound) return;
          zoom._zoomBound = true;
          zoom.addEventListener('pointerenter', function () {
            self._zoomRect = zoom.getBoundingClientRect();
            self._activeZoom = zoom;
          });
          zoom.addEventListener('pointerleave', function () {
            self._activeZoom = null;
            self._zoomRect = null;
            zoom.style.setProperty('--mx', 50);
            zoom.style.setProperty('--my', 50);
          });
          zoom.addEventListener('pointermove', function (e) {
            if (self._zoomRaf || self._activeZoom !== zoom || !self._zoomRect) return;
            self._zoomRaf = requestAnimationFrame(function () {
              self._zoomRaf = 0;
              var r = self._zoomRect;
              if (!r) return;
              var mx = ((e.clientX - r.left) / r.width * 100).toFixed(1);
              var my = ((e.clientY - r.top) / r.height * 100).toFixed(1);
              zoom.style.setProperty('--mx', mx);
              zoom.style.setProperty('--my', my);
            });
          });
        };
        var first = this.querySelector('.product__media-item.is-active .product__zoom');
        this._bindZoom(first);
      }
    }

    switchTo(mediaId) {
      var activeItem = null;
      var activeIndex = 1;

      this.items.forEach(function (item) {
        var isActive = item.dataset.mediaId === String(mediaId);
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          activeItem = item;
          activeIndex = parseInt(item.dataset.mediaIndex, 10) || 1;
          item.removeAttribute('aria-hidden');
          item.removeAttribute('inert');
        } else {
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('inert', '');
        }
      });

      this.thumbs.forEach(function (thumb) {
        var isActive = thumb.dataset.mediaId === String(mediaId);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        thumb.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      if (activeItem && this.counterIdx) {
        this.counterIdx.textContent = ('00' + activeIndex).slice(-2);
      }
      if (activeItem && this.counterKind) {
        var k = activeItem.dataset.mediaKind || 'image';
        var label = (k === 'video' || k === 'external_video') ? 'Video'
                  : (k === 'model') ? '3D'
                  : 'Image';
        this.counterKind.textContent = label;
      }
      if (activeItem && this.progress && this.total > 0) {
        var pct = (activeIndex / this.total * 100);
        this.progress.style.setProperty('--gallery-progress', pct.toFixed(1));
        this.progress.setAttribute('aria-valuenow', Math.round(pct));
      }

      if (this._canZoom && activeItem) {
        var nextZoom = activeItem.querySelector('.product__zoom');
        if (nextZoom && this._bindZoom) this._bindZoom(nextZoom);
        this._activeZoom = null;
        this._zoomRect = null;
      }
    }
  });

  /* --- CartItems (drawer + page qty / remove) ---------------- */
  function changeCartLine(line, quantity, root) {
    var loader = root && root.querySelector('[data-cart-loading]');
    if (loader) loader.hidden = false;
    return fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: cartSectionList(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        updateCartSections(data.sections);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        return data;
      })
      .finally(function () { if (loader) loader.hidden = true; });
  }
  theme.changeCartLine = changeCartLine;

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeCartLine(parseInt(remove.dataset.cartRemove, 10), 0, remove.closest('[data-cart-section]'));
    }
  });
  document.addEventListener('change', function (e) {
    var qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      var line = parseInt(qty.dataset.cartQty, 10);
      var val = Math.max(0, parseInt(qty.value, 10) || 0);
      changeCartLine(line, val, qty.closest('[data-cart-section]'));
    }
  });

  /* --- Update order note ------------------------------------- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(theme.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  /* --- Money formatter --------------------------------------- */
  theme.formatMoney = function (cents) {
    var value = (cents / 100).toFixed(2);
    var format = theme.moneyFormat || '${{amount}}';
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  };

  /* --- PredictiveSearch element ------------------------------ */
  defineEl('predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      if (!this.input || !theme.routes.predictiveSearch) return;
      this.timer = null;
      this.input.addEventListener('input', this.onInput.bind(this));
    }
    onInput() {
      var q = this.input.value.trim();
      clearTimeout(this.timer);
      if (q.length < 2) { this.results.innerHTML = ''; return; }
      var self = this;
      this.timer = setTimeout(function () {
        var url = theme.routes.predictiveSearch +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive-results]');
          self.results.innerHTML = inner ? inner.innerHTML : '';
        });
      }, 240);
    }
  });

  /* --- CollectionFilters element ----------------------------- */
  defineEl('collection-filters', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      var self = this;
      this.form.addEventListener('input', function (e) {
        if (e.target.type === 'text' || e.target.type === 'number') return;
        self.syncFacetState();
        self.apply();
      });
      this.form.addEventListener('change', function (e) {
        if (e.target.tagName === 'SELECT') self.apply();
        else self.syncFacetState();
      });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.apply(); });
      this.syncFacetState();
    }
    syncFacetState() {
      var inputs = this.querySelectorAll('.facet-check input[type="checkbox"]:checked');
      var n = inputs.length;
      this.dataset.activeCount = String(n);
      var countEl = this.querySelector('[data-facet-count]');
      if (countEl) countEl.textContent = String(n);
      var liveEl = this.querySelector('[data-facet-live]');
      if (liveEl) {
        liveEl.textContent = n === 0 ? '' : (n + ' filter' + (n === 1 ? '' : 's') + ' selected');
      }
    }
    apply() {
      var params = new URLSearchParams(new FormData(this.form));
      var url = window.location.pathname + '?' + params.toString();
      var self = this;
      this.classList.add('is-loading');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-filter-results]', '[data-filter-facets]', '[data-filter-toolbar]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var current = document.querySelector(sel);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        $$('.reveal, .reveal-stagger', self).forEach(function (el) { el.classList.add('is-visible'); });
        window.history.pushState({}, '', url);
        self.classList.remove('is-loading');
        self.syncFacetState();
        window.scrollTo({ top: self.offsetTop - 120, behavior: 'smooth' });
      });
    }
  });

  /* --- AnnouncementBar rotation ------------------------------ */
  defineEl('announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement__track');
      this.items = $$('.announcement__item', this);
      if (this.items.length < 2) return;
      this.index = 0;
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.autorotate = this.dataset.rotate === 'true';
      var self = this;
      var prev = this.querySelector('[data-announcement-prev]');
      var next = this.querySelector('[data-announcement-next]');
      if (prev) prev.addEventListener('click', function () { self.advance(-1); self.restartTimer(); });
      if (next) next.addEventListener('click', function () { self.advance(1); self.restartTimer(); });
      if (this.autorotate) this.startTimer();
    }
    advance(dir) {
      this.index = (this.index + dir + this.items.length) % this.items.length;
      this.track.style.transform = 'translate3d(' + (this.index * -100) + '%, 0, 0)';
    }
    startTimer() {
      var self = this;
      clearInterval(this.timer);
      this.timer = setInterval(function () { self.advance(1); }, this.speed);
    }
    restartTimer() {
      if (this.autorotate) this.startTimer();
      else clearInterval(this.timer);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });

  /* --- Hero slideshow ---------------------------------------- */
  defineEl('slideshow-hero', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.slideshow__track');
      this.slides = $$('.slideshow__slide', this);
      if (this.slides.length < 2) return;
      this.index = 0;
      this.speed = (parseFloat(this.dataset.speed) || 6) * 1000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.dots = $$('[data-slideshow-dot]', this);
      var self = this;
      var prev = this.querySelector('[data-slideshow-prev]');
      var next = this.querySelector('[data-slideshow-next]');
      if (prev) prev.addEventListener('click', function () { self.go(-1); self.restartTimer(); });
      if (next) next.addEventListener('click', function () { self.go(1); self.restartTimer(); });
      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () { self.goTo(parseInt(dot.dataset.slideshowDot, 10)); self.restartTimer(); });
      });
      this.addEventListener('mouseenter', function () { clearInterval(self.timer); });
      this.addEventListener('mouseleave', function () { if (self.autoplay) self.startTimer(); });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.go(-1); self.restartTimer(); }
        else if (e.key === 'ArrowRight') { self.go(1); self.restartTimer(); }
      });
      var startX = null;
      this.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a, button, input, textarea, select')) return;
        startX = e.clientX;
      });
      this.addEventListener('pointerup', function (e) {
        if (startX == null) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 50) { dx < 0 ? self.go(1) : self.go(-1); self.restartTimer(); }
        startX = null;
      });
      this.addEventListener('pointercancel', function () { startX = null; });
      if (this.autoplay) this.startTimer();
    }
    goTo(idx) {
      this.index = ((idx % this.slides.length) + this.slides.length) % this.slides.length;
      this.track.style.transform = 'translate3d(' + (this.index * -100) + '%, 0, 0)';
      var current = this.index;
      this.dots.forEach(function (d, i) {
        var active = i === current;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    go(dir) { this.goTo(this.index + dir); }
    startTimer() {
      var self = this;
      clearInterval(this.timer);
      this.timer = setInterval(function () { self.go(1); }, this.speed);
    }
    restartTimer() { if (this.autoplay) this.startTimer(); }
    disconnectedCallback() { clearInterval(this.timer); }
  });

  /* --- Header scroll state ----------------------------------- */
  function initHeader() {
    var header = $('.header');
    if (!header) return;
    var last = 0;
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Scroll reveal ----------------------------------------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal, .reveal-stagger').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });
  }

  /* --- Product card swatches --------------------------------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.card-swatch');
    if (!sw || sw.disabled) return;
    var card = sw.closest('.product-card');
    if (!card) return;
    e.preventDefault();
    card.querySelectorAll('.card-swatch').forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
    });
    if (sw.dataset.variantId) {
      var input = card.querySelector('[data-card-variant-input]');
      if (input) input.value = sw.dataset.variantId;
    }
  });

  /* --- Share: native Web Share API ([data-share]) ------------ */
  document.addEventListener('click', function (e) {
    var share = e.target.closest('[data-share]');
    if (!share) return;
    var url = share.dataset.share || window.location.href;
    if (navigator.share) {
      navigator.share({ url: url, title: document.title }).catch(function () {});
    } else {
      navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
    }
  });

  /* --- Share: Copy Link chip ([data-share-copy]) -------------- */
  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-share-copy]');
    if (!copy) return;
    e.preventDefault();
    var url = copy.dataset.shareCopy || window.location.href;
    var done = function () {
      copy.classList.add('is-copied');
      toast('Link copied');
      setTimeout(function () { copy.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
    } else {
      window.prompt('Copy this link:', url);
    }
  });

  /* --- Share: reveal native "More" chip if Web Share supported */
  function revealNativeShareChips() {
    if (!('share' in navigator)) return;
    document.querySelectorAll('.share-chip--more[hidden]').forEach(function (chip) {
      chip.removeAttribute('hidden');
    });
  }
  if (document.readyState !== 'loading') revealNativeShareChips();
  else document.addEventListener('DOMContentLoaded', revealNativeShareChips);
  document.addEventListener('shopify:section:load', revealNativeShareChips);

  /* --- Accordion smooth animation (height-measure) ---------- */
  /* JS-orchestrated symmetric open/close for <details class="accordion__item">.
     Preserves native a11y (keyboard, [open] attr, SR announcements).
     - Spam-click safe: clears prior listener AND timeout before each new animation
     - will-change set only during active animation (no persistent compositor cost)
     - js-accordion-ready class added synchronously to avoid FOUC on slow devices
     - shopify:section:load hook re-asserts class for theme editor */
  document.documentElement.classList.add('js-accordion-ready');
  (function () {
    var DURATION = 240;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var states = new WeakMap();

    function animateItem(item, opening) {
      var content = item.querySelector(':scope > .accordion__content');
      if (!content) return;

      if (reduced.matches) {
        if (opening) item.setAttribute('open', '');
        else item.removeAttribute('open');
        content.style.cssText = '';
        states.delete(item);
        return;
      }

      // Cancel in-flight: BOTH listener and timeout (spam-click safety)
      var prev = states.get(item);
      if (prev) {
        if (prev.onEnd) content.removeEventListener('transitionend', prev.onEnd);
        if (prev.timeout) clearTimeout(prev.timeout);
        states.delete(item);
      }
      var startH = content.getBoundingClientRect().height;
      content.style.willChange = 'height';

      if (opening) {
        item.setAttribute('open', '');
        content.style.height = 'auto';
        var target = content.scrollHeight;
        content.style.height = startH + 'px';
        if (startH === 0) content.style.opacity = '0';
        void content.offsetHeight;
        content.style.height = target + 'px';
        content.style.opacity = '1';
      } else {
        content.style.height = startH + 'px';
        void content.offsetHeight;
        content.style.height = '0px';
        content.style.opacity = '0';
      }

      var onEnd = function (e) {
        if (e && e.propertyName && e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);
        content.style.willChange = '';
        if (opening) {
          content.style.height = '';
          content.style.opacity = '';
        } else {
          item.removeAttribute('open');
          content.style.cssText = '';
        }
        states.delete(item);
      };
      content.addEventListener('transitionend', onEnd);
      var timeout = setTimeout(function () { onEnd({ propertyName: 'height' }); }, DURATION + 80);
      states.set(item, { onEnd: onEnd, timeout: timeout });
    }

    // Delegated click — covers mouse + keyboard (Space/Enter fires click on <summary>)
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.accordion__item > .accordion__summary');
      if (!summary) return;
      e.preventDefault();
      var item = summary.parentElement;
      animateItem(item, !item.hasAttribute('open'));
    });

    document.addEventListener('shopify:section:load', function () {
      document.documentElement.classList.add('js-accordion-ready');
    });
  })();

  /* --- Video feature — click-to-play / external URL handoff --- */
  defineEl('video-feature', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.video = this.querySelector('[data-vf-video]');
      this.url = this.dataset.url || '';
      this.playBtn = this.querySelector('[data-vf-play]');
      var trigger = function (e) {
        e.preventDefault();
        if (self.url) {
          // YouTube / Vimeo / external link — open in new tab (don't fight platform UX)
          window.open(self.url, '_blank', 'noopener');
          return;
        }
        if (!self.video) return;
        self.classList.add('is-playing');
        var p = self.video.play();
        if (p && p.catch) p.catch(function () { /* autoplay gesture rejected — ignore */ });
      };
      if (this.playBtn) this.playBtn.addEventListener('click', trigger);
      if (this.video) {
        this.video.addEventListener('ended', function () { self.classList.remove('is-playing'); });
      }
    }
  });

  /* --- MegaMenu (Sprint 8 — editorial rail + preview + side feature) -- */
  defineEl('mega-menu', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-mm-trigger]');
      this.panel = this.querySelector('[data-mm-panel]');
      this.rail = this.querySelector('[data-mm-rail]');
      this.preview = this.querySelector('[data-mm-preview]');
      this.status = this.querySelector('[data-mm-status]');
      if (!this.trigger || !this.panel || !this.rail || !this.preview) return;

      var self = this;
      this.items = $$('[data-mm-rail-item]', this);
      this.templates = $$('template[data-mm-pane]', this);
      this.hydrated = new Set([0]);
      this.activeIndex = 0;
      this.isCoarse = window.matchMedia('(pointer: coarse), (hover: none)').matches;
      this._openTimer = null;
      this._closeTimer = null;
      this._suppressClick = false;

      this.trigger.addEventListener('click', function (e) {
        if (self._suppressClick) { self._suppressClick = false; return; }
        e.preventDefault();
        self.isOpen() ? self.close() : self.open();
      });
      this.trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          self._suppressClick = true;
          queueMicrotask(function () { self._suppressClick = false; });
          self.open();
          if (self.items[0]) self.items[0].focus();
        }
      });

      if (!this.isCoarse) {
        this.addEventListener('mouseenter', function () {
          clearTimeout(self._closeTimer);
          self._openTimer = setTimeout(function () { self.open(); }, 80);
        });
        this.addEventListener('mouseleave', function () {
          clearTimeout(self._openTimer);
          self._closeTimer = setTimeout(function () { self.close(); }, 140);
        });
      }

      this.addEventListener('focusin', function () {
        clearTimeout(self._closeTimer);
        self.open();
      });
      this.addEventListener('focusout', function () {
        requestAnimationFrame(function () {
          if (!self.contains(document.activeElement)) self.close();
        });
      });

      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen()) {
          self.close();
          self.trigger.focus();
        }
      });

      this.items.forEach(function (item, i) {
        var activate = function () { self.activate(i); };
        item.addEventListener('mouseenter', activate);
        item.addEventListener('focus', activate);
        item.addEventListener('keydown', function (e) { self.onRailKey(e, i); });
      });

      // Anchor panel below the actual header height (not a hardcoded 70px)
      this._setHeaderHeight();
      this._onResize = function () { self._setHeaderHeight(); };
      window.addEventListener('resize', this._onResize, { passive: true });
    }

    _setHeaderHeight() {
      var header = document.querySelector('.header');
      if (!header) return;
      var h = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    isOpen() { return this.dataset.open === 'true'; }

    open() {
      if (this.isOpen()) return;
      this.dataset.open = 'true';
      var navItem = this.closest('.nav-item');
      if (navItem) navItem.setAttribute('data-open', 'true');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (!this.isOpen()) return;
      this.dataset.open = 'false';
      var navItem = this.closest('.nav-item');
      if (navItem) navItem.removeAttribute('data-open');
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    activate(i) {
      if (i === this.activeIndex) return;
      this.activeIndex = i;
      this.items.forEach(function (it, idx) {
        if (idx === i) it.setAttribute('data-active', 'true');
        else it.removeAttribute('data-active');
      });
      this.hydrate(i);
      if (this.status) this.status.textContent = (this.items[i].textContent || '').trim() + ' previewed';
    }

    hydrate(i) {
      if (this.hydrated.has(i)) {
        this.swapPane(i);
        return;
      }
      var tpl = this.templates.find(function (t) { return Number(t.dataset.mmIndex) === i; });
      if (!tpl) return;
      var frag = tpl.content.cloneNode(true);
      frag.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.setAttribute('loading', 'lazy');
      });
      var wrapper = document.createElement('div');
      wrapper.setAttribute('data-mm-pane-rendered', String(i));
      wrapper.appendChild(frag);
      this.preview.appendChild(wrapper);
      this.hydrated.add(i);
      this.swapPane(i);
    }

    swapPane(i) {
      var panes = this.preview.querySelectorAll('[data-mm-pane-rendered]');
      panes.forEach(function (node) {
        node.hidden = Number(node.getAttribute('data-mm-pane-rendered')) !== i;
      });
    }

    onRailKey(e, i) {
      var last = this.items.length - 1;
      var next = null;
      if (e.key === 'ArrowDown') next = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowUp') next = i === 0 ? last : i - 1;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = last;
      if (next !== null) { e.preventDefault(); this.items[next].focus(); }
    }
  });

  // Outside-click dismiss for any open mega-menu
  document.addEventListener('click', function (e) {
    document.querySelectorAll('mega-menu[data-open="true"]').forEach(function (mm) {
      if (!mm.contains(e.target)) mm.close();
    });
  });

  /* --- SortPill: custom sort menu replacing native select (Sprint 6b) --- */
  defineEl('sort-pill', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.select = this.querySelector('select');
      this.btn = this.querySelector('.sort-pill__btn');
      this.menu = this.querySelector('.sort-pill__menu');
      this.valueEl = this.querySelector('[data-sort-current-label]');
      if (!this.select || !this.btn || !this.menu) return;

      this.options = Array.from(this.menu.querySelectorAll('.sort-pill__option'));

      this.btn.addEventListener('click', function () { self.toggle(); });

      this.options.forEach(function (opt) {
        opt.addEventListener('click', function () { self.select_(opt); });
      });

      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { self.close(); self.btn.focus(); return; }
        if (!self.isOpen()) return;
        var idx = self.options.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var next = self.options[Math.min(idx + 1, self.options.length - 1)] || self.options[0];
          next.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = self.options[Math.max(idx - 1, 0)] || self.options[self.options.length - 1];
          prev.focus();
        } else if (e.key === 'Home') { e.preventDefault(); self.options[0].focus(); }
          else if (e.key === 'End') { e.preventDefault(); self.options[self.options.length - 1].focus(); }
      });

      document.addEventListener('click', function (e) {
        if (!self.contains(e.target) && self.isOpen()) self.close();
      });
    }
    isOpen() { return !this.menu.hidden; }
    toggle() { this.isOpen() ? this.close() : this.open(); }
    open() {
      this.menu.hidden = false;
      this.btn.setAttribute('aria-expanded', 'true');
      this.classList.add('sort-pill--open');
      var current = this.menu.querySelector('.is-current') || this.options[0];
      if (current) current.focus();
    }
    close() {
      this.menu.hidden = true;
      this.btn.setAttribute('aria-expanded', 'false');
      this.classList.remove('sort-pill--open');
    }
    select_(opt) {
      var value = opt.dataset.value;
      var label = opt.dataset.label;
      this.options.forEach(function (o) {
        o.classList.toggle('is-current', o === opt);
        o.parentElement.setAttribute('aria-selected', o === opt ? 'true' : 'false');
      });
      if (this.valueEl) this.valueEl.textContent = label;
      this.select.value = value;
      this.close();
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* --- PdpStickyBuy: viewport-fixed compact buy bar (Sprint 6a) -- */
  defineEl('pdp-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.formId = this.dataset.form;
      this.form = document.getElementById(this.formId);
      if (!this.form) return;
      this.ctaRow = this.form.querySelector('.product-form__cta-row');
      this.submitBtn = this.querySelector('[data-pdp-sticky-submit]');
      if (!this.ctaRow || !this.submitBtn) return;

      this.hidden = false;
      this.removeAttribute('hidden');
      this.classList.remove('pdp-sticky-buy--visible');

      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show bar only when the main CTA is OFF-screen (below or above viewport).
          self.classList.toggle('pdp-sticky-buy--visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });
      this.io.observe(this.ctaRow);

      // Relay click → submit main form (preserve variant, cart-drawer, analytics).
      this.submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (self.submitBtn.disabled) return;
        if (self.form.requestSubmit) self.form.requestSubmit();
        else self.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });

      // Hide while any drawer is open (cart, mobile nav, search) via body class — pure CSS handles it.

      // Live variant sync: when main form's variant id / submit button state changes,
      // mirror onto sticky bar.
      this.mainSubmit = this.form.querySelector('[type="submit"]');
      this.priceMain = document.getElementById('price-' + this.dataset.section);
      this.priceStick = this.querySelector('[data-pdp-sticky-price]');
      this.mo = new MutationObserver(function () { self.syncFromMain(); });
      if (this.mainSubmit) this.mo.observe(this.mainSubmit, { attributes: true, attributeFilter: ['disabled'] });
      if (this.priceMain) this.mo.observe(this.priceMain, { childList: true, subtree: true, characterData: true });
    }
    syncFromMain() {
      if (this.mainSubmit && this.submitBtn) {
        this.submitBtn.disabled = this.mainSubmit.disabled;
        var label = this.mainSubmit.querySelector('span');
        var stickyLabel = this.submitBtn.querySelector('span');
        if (label && stickyLabel) stickyLabel.textContent = label.textContent;
      }
      if (this.priceMain && this.priceStick) {
        this.priceStick.innerHTML = this.priceMain.innerHTML;
      }
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
    }
  });

  /* --- Reading progress bar (article body scroll → scaleX) ---- */
  (function () {
    var bar, body, ticking = false, bound = false;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init() {
      bar = document.querySelector('.reading-progress__bar');
      body = document.querySelector('.article__body');
      if (!bar || !body) return;
      if (!bound) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        bound = true;
      }
      update();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    function update() {
      if (!bar || !body) return;
      var rect = body.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var anchorTop = viewportH * 0.6;
      var anchorBot = viewportH * 0.4;
      var bodyTop = rect.top;
      var bodyBottom = rect.bottom;
      var progress;
      if (bodyTop > anchorTop) progress = 0;
      else if (bodyBottom < anchorBot) progress = 1;
      else {
        var span = (bodyBottom - bodyTop) - (anchorTop - anchorBot);
        progress = span > 0 ? (anchorTop - bodyTop) / span : 1;
      }
      if (progress < 0) progress = 0; else if (progress > 1) progress = 1;
      if (reduceMotion) progress = Math.round(progress * 5) / 5;
      bar.style.transform = 'scaleX(' + progress + ')';
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  /* --- Init / re-init for theme editor ----------------------- */
  function init(scope) {
    initHeader();
    initReveal();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function () { initReveal(); initHeader(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#CartDrawer')) DrawerManager.open(document.getElementById('CartDrawer'));
  });

  window.theme = theme;
})();
